import { getStoreSteamAnalysis } from '@/pages/opinion/services';
import { supplementSingleData } from '@/pages/opinion/utils';
import { sortLegend } from '@op/pages/SteamPerformance/utils';
import { DBO_V } from '@op/utils/format';
import _ from 'lodash-es';
import { useEffect, useState } from 'react';

export default function useSteamGameStoreAnalysis({
  filter,
  metrics,
  initValue,
}: any) {
  const [loading, setLoading] = useState(false);
  const [storeSteamData, setStoreSteamData] = useState<{ [key: string]: [] }>(
    initValue,
  );

  useEffect(() => {
    setLoading(true);
    getStoreSteamAnalysis({
      ...filter,
      metrics,
      channel: ['steam'],
    })
      .then((data: any) => {
        const {
          timeline_list,
          list,
          timeline_of_end_time,
          timeline_of_start_time,
        } = data || {};

        const tableList: any = {};
        const chartList: any = {};
        _.forEach(list, (item: any, key: string) => {
          item?.sort?.(sortLegend('key', false));
          const tableData = item.map((info: any) => {
            return {
              ...info,
              positive_ratio_value: DBO_V.percentageValue(
                info.positive,
                info.count,
                8,
              ),
              positive_ratio: DBO_V.percentage(info.positive, info.count, 2),
              negative_ratio_value: DBO_V.percentageValue(
                info.negative,
                info.count,
                8,
              ),
              negative_ratio: DBO_V.percentage(info.negative, info.count, 2),
            };
          }); 
          tableData.reverse();
          tableList[`${key}_table`] = tableData;
          chartList[key] = item;
        });

        const result = { ...tableList, ...chartList };
        Object.keys(timeline_list || {}).forEach(item => {
          const newList = supplementSingleData(
            timeline_of_start_time,
            timeline_of_end_time,
            (timeline_list[item] || []).map((info: { key: any }) => ({
              ...info,
              name: info.key,
            })),
            filter.date_type,
          );
          result[item] = newList;
        });
        setStoreSteamData(result);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [filter]);

  return {
    storeSteamData,
    loading,
  };
}
